import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import ConfirmProductCreation from "../forms/ConfirmProductCreation";
import CreateProductForm from "../forms/CreateProductForm";
import ImagePicker from "../forms/ImagePicker";
import API from "../../api";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { hideModalCreate, listProducts } from "../../actions/productActions";

const TOTAL_STEPS = 3;

const stepDescription = [
  "Cuéntanos sobre tu producto",
  "Sube una imagen de tu producto",
  "Confirma los datos",
];

const CreateProductModal = ({ isOpen }) => {
  const isVisible = useSelector((state) => state.productCreate.modalCreate);
  const dispatch = useDispatch();

  const [productData, setProductData] = useState({
    name: "",
    price: "",
    description: "",
    category: "",
    store: "",
    image: "",
  });

  const [image, setImage] = useState(null);
  const [rawImage, setRawImage] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);

  const [loading, setLoading] = useState(false);

  const onClose = () => {
    dispatch(hideModalCreate());
  };

  const cancelar = () => {
    setProductData({
      name: "",
      price: "",
      description: "",
      category: "",
      store: "",
      image: "",
    });
    setImage(null);
    setRawImage(null);
    setCurrentStep(1);
    onClose();
  };

  const handleCreateProduct = async () => {
    setLoading(true);
    let tempKey = null;
    try {
      const { image } = await uploadImagesToS3({ image: rawImage });

      if (!image.location.secure_url)
        throw new Error({ message: "Error al subir las imágenes" });

      const urls = {
        image: image.location.secure_url,
      };

      tempKey = image.location.public_id;

      const product = {
        ...productData,
        stores: [productData.store],
        images: [urls.image],
        imagesDeleteIds: [tempKey],
      };

      await API.post("/products", product);
      setLoading(false);
      toast.success("Producto creado con éxito", {
        icon: "👏",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });

      dispatch(listProducts());
      cancelar();
    } catch (err) {
      console.log({ err });
      toast.error("Error al crear producto", {
        icon: "😰",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });
      await deleteImagesFromS3([tempKey]);
      setLoading(false);
    }
  };

  const deleteImagesFromS3 = (keys) => {
    return Promise.all(
      keys.map(async (key) => {
        console.log({ key });
        await API.delete(`/uploads`, { data: { id: key } });
      })
    );
  };

  const uploadImagesToS3 = async ({ image }) => {
    const formData = new FormData();
    formData.append("file", image);

    try {
      const imageRes = await API.post("/uploads", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return {
        image: imageRes.data,
      };
    } catch (err) {
      console.log({ err });
      throw new Error({ message: "Error al subir las imágenes" });
    }
  };

  return (
    <Modal
      isOpen={isVisible}
      onClose={cancelar}
      size="lg"
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text fontSize="2xl">Crear Producto</Text>
          <Text fontSize="md" fontWeight="light">
            {currentStep}/{TOTAL_STEPS} {stepDescription[currentStep - 1]}
          </Text>
        </ModalHeader>

        <ModalCloseButton />
        <ModalBody>
          {currentStep === 1 && (
            <CreateProductForm
              productData={productData}
              setProductData={setProductData}
              nextStep={() => setCurrentStep(2)}
            />
          )}
          {currentStep === 2 && (
            <ImagePicker
              image={image}
              rawImage={rawImage}
              setRawImage={setRawImage}
              setImage={setImage}
              nextStep={() => setCurrentStep(3)}
              prevStep={() => setCurrentStep(1)}
            />
          )}
          {currentStep === 3 && (
            <ConfirmProductCreation
              product={{
                ...productData,
                image,
              }}
              onConfirm={handleCreateProduct}
              onCancel={cancelar}
              loading={loading}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CreateProductModal;
